import { Card, Typography } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useDashboardFilters } from '@contexts'
import { useDashboardData } from '@hooks'

import { ContentContainer } from '../../../../components/StyledComponents'
import {
  CarrierSelector,
  DailyMetricsTable,
  HeaderRow,
  SupplierSelector,
  TripTypeSelector,
  WeekSelector,
  WeeklyMetricsTable,
} from '../components'

const WeeklyDashboard = () => {
  const { t } = useTranslation()
  const { resetFiltersToDefaults } = useDashboardFilters()

  useEffect(() => {
    resetFiltersToDefaults()
  }, [resetFiltersToDefaults])

  // Combined metrics with full supplier/carrier lists
  const { dailyData, weeklyData, isError, isLoadingWeekly, isLoadingDaily } = useDashboardData()

  return (
    <ContentContainer span={24}>
      <HeaderRow className="filters-list">
        <WeekSelector />
        <TripTypeSelector />
        <SupplierSelector />
        <CarrierSelector />
      </HeaderRow>
      <Card size="small" style={{ margin: '0 0.5rem' }} styles={{ body: { padding: '1.5rem' } }}>
        {isError && (
          <Typography.Text type="danger">
            {t('admin_router.dashboard.load_error_daily')}
          </Typography.Text>
        )}
        {!isError && <DailyMetricsTable data={dailyData} isLoading={isLoadingDaily} />}
      </Card>
      <Card
        size="small"
        style={{ margin: '1rem 0.5rem 0 0.5rem' }}
        styles={{ body: { padding: '1.5rem' } }}
      >
        {isError && (
          <Typography.Text type="danger">{t('admin_router.dashboard.load_error')}</Typography.Text>
        )}
        {!isError && <WeeklyMetricsTable data={weeklyData} isLoading={isLoadingWeekly} />}
      </Card>
    </ContentContainer>
  )
}

export { WeeklyDashboard }
